import { render, staticRenderFns } from "./StLoader.vue?vue&type=template&id=cc1de65e&"
import script from "./StLoader.vue?vue&type=script&lang=js&"
export * from "./StLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports